<template>
    
    <v-card>
    <v-card-title>
        <span class="headline">Análisis individual</span> 
    </v-card-title>

    <v-card-subtitle>
        {{serie.nombre}}
    </v-card-subtitle>

    <v-card-text>

        <v-select
            v-model="selected"
            outline
            :items="options"
            menu-props="auto"
            hide-details
            label="Seleccionar variable"
            v-on:change="changeSelected"
            item-text="name"
        ></v-select>

        <apexcharts type="line" :options="chartOptions" :series="series"></apexcharts>

        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
        >
            <template v-slot:item.success="{ item }">
                {{isSuccess(item.success)}}
            </template>
            <template v-slot:item.latency="{ item }">
                {{round(item.latency)}}
            </template>
            <template v-slot:item.straightness="{ item }">
                {{round3(item.straightness)}}
            </template>
            <template v-slot:item.pathlength="{ item }">
                {{round(item.pathlength)}}
            </template>

            <template v-slot:item.orientation_time="{ item }">
                {{round(item.orientation_time)}}
            </template>
            <template v-slot:item.orientation_distance="{ item }">
                {{round(item.orientation_distance)}}
            </template>
            <template v-slot:item.normalized_orientation_distance="{ item }">
                {{round(item.normalized_orientation_distance)}}
            </template>
            <template v-slot:item.mixed_orientation_time="{ item }">
                {{round(item.mixed_orientation_time)}}
            </template>
            <template v-slot:item.center_time="{ item }">
                {{round(item.center_time)}}
            </template>
            <template v-slot:item.speed_time="{ item }">
                {{round3(item.speed_time)}}
            </template>
            <template v-slot:item.step_correlation="{ item }">
                {{round3(item.step_correlation)}}
            </template>
            <template v-slot:item.meander="{ item }">
                {{round3(item.meander)}}
            </template>
            <template v-slot:item.quadrant_time="{ item }">
                {{round3(item.quadrant_time)}}
            </template>
            <template v-slot:item.error_entropy="{ item }">
                {{round3(item.error_entropy)}}
            </template>
            <template v-slot:item.path_entropy="{ item }">
                {{round3(item.path_entropy)}}
            </template>

            <template v-slot:item.angle_to_objective_mean="{ item }">
                {{round(item.angle_to_objective_mean)}}
            </template>
            <template v-slot:item.angle_to_objective_std="{ item }">
                {{round(item.angle_to_objective_std)}}
            </template>
            <template v-slot:item.movement_direction_mean="{ item }">
                {{round(item.movement_direction_mean)}}
            </template>
            <template v-slot:item.movement_direction_std="{ item }">
                {{round(item.movement_direction_std)}}
            </template>
            <template v-slot:item.distance_to_objective_mean="{ item }">
                {{round(item.distance_to_objective_mean)}}
            </template>
            <template v-slot:item.distance_to_objective_std="{ item }">
                {{round(item.distance_to_objective_std)}}
            </template>
            <template v-slot:item.distance_to_center_mean="{ item }">
                {{round(item.distance_to_center_mean)}}
            </template>
            <template v-slot:item.distance_to_center_std="{ item }">
                {{round(item.distance_to_center_std)}}
            </template>
            <template v-slot:item.angle_to_center_mean="{ item }">
                {{round(item.angle_to_center_mean)}}
            </template>
            <template v-slot:item.angle_to_center_std="{ item }">
                {{round(item.angle_to_center_std)}}
            </template>
            <template v-slot:item.turning_angle_mean="{ item }">
                {{round3(item.turning_angle_mean)}}
            </template>
            <template v-slot:item.turning_angle_std="{ item }">
                {{round3(item.turning_angle_std)}}
            </template>
        </v-data-table>
    </v-card-text>

    <v-card-actions>
        <v-btn color="blue darken-1" text @click="openDiagrama">Diagramas</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="updateClose">Cerrar</v-btn>
    </v-card-actions>
    </v-card>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'

    export default {
    props: ["item", "dialog"],

    data: () => ({
        selected: {name: 'Acierto', key: 'success' },
        optionsBase: [
            { name: 'Acierto', key: 'success' },
            { name: 'Latencia (seg)', key: 'latency' },
            { name: 'Distancia (m)', key: 'pathlength' },
            { name: 'Rectitud', key: 'straightness' },

            { name: 'Tiempo de orientación (seg)', key: 'orientation_time' },
            { name: 'Distancia de orientación (m)', key: 'orientation_distance' },
            { name: 'Distancia de orientación normalizada', key: 'normalized_orientation_distance' },
            { name: 'Tiempo de orientación mezclado (seg)', key: 'mixed_orientation_time' },
            { name: 'Tiempo en el centro (seg)', key: 'center_time' },
            { name: 'Tiempo en movimiento', key: 'speed_time' },
            { name: 'Correlación de ángulo', key: 'step_correlation' },
            { name: 'Correlación giro-movimiento', key: 'meander' },
            { name: 'Tiempo en cuadrante objetivo', key: 'quadrant_time' },
            { name: 'Entropía del error', key: 'error_entropy' },
            { name: 'Entropía del camino', key: 'path_entropy' },

            { name: 'Ángulo al objetivo (prom)', key: 'angle_to_objective_mean' },
            { name: 'Ángulo al objetivo (s.d.)', key: 'angle_to_objective_std' },
            { name: 'Ángulo de movimiento (prom)', key: 'movement_direction_mean' },
            { name: 'Ángulo de movimiento (s.d.)', key: 'movement_direction_std' },
            { name: 'Distancia al objetivo (prom)', key: 'distance_to_objective_mean' },
            { name: 'Distancia al objetivo (s.d.)', key: 'distance_to_objective_std' },
            { name: 'Distancia al centro (prom)', key: 'distance_to_center_mean' },
            { name: 'Distancia al centro (s.d.)', key: 'distance_to_center_std' },
            { name: 'Ángulo al centro (prom)', key: 'angle_to_center_mean' },
            { name: 'Ángulo al centro (s.d.)', key: 'angle_to_center_std' },
            { name: 'Ángulo de giro (prom)', key: 'turning_angle_mean' },
            { name: 'Ángulo de giro (s.d.)', key: 'turning_angle_std' },
        ],
        headersBase: [
            {
                text: 'Número',
                value: 'number',
            },
            {
                text: 'Nombre',
                align: 'start',
                value: 'name',
            },
            { text: 'Acierto', value: 'success' },
            { text: 'Latencia (seg)', value: 'latency' },
            { text: 'Distancia (m)', value: 'pathlength' },
            { text: 'Rectitud', value: 'straightness' },

            { text: 'Tiempo de orientación (seg)', value: 'orientation_time' },
            { text: 'Distancia de orientación (m)', value: 'orientation_distance' },
            { text: 'Distancia de orientación normalizada', value: 'normalized_orientation_distance' },
            { text: 'Tiempo de orientación mezclado (seg)', value: 'mixed_orientation_time' },
            { text: 'Tiempo en el centro (seg)', value: 'center_time' },
            { text: 'Tiempo en movimiento', value: 'speed_time' },
            { text: 'Correlación de ángulo', value: 'step_correlation' },
            { text: 'Correlación giro-movimiento', value: 'meander' },
            { text: 'Tiempo en cuadrante objetivo', value: 'quadrant_time' },
            { text: 'Entropía del error', value: 'error_entropy' },
            { text: 'Entropía del camino', value: 'path_entropy' },

            { text: 'Ángulo al objetivo (prom)', value: 'angle_to_objective_mean' },
            { text: 'Ángulo al objetivo (s.d.)', value: 'angle_to_objective_std' },
            { text: 'Ángulo de movimiento (prom)', value: 'movement_direction_mean' },
            { text: 'Ángulo de movimiento (s.d.)', value: 'movement_direction_std' },
            { text: 'Distancia al objetivo (prom)', value: 'distance_to_objective_mean' },
            { text: 'Distancia al objetivo (s.d.)', value: 'distance_to_objective_std' },
            { text: 'Distancia al centro (prom)', value: 'distance_to_center_mean' },
            { text: 'Distancia al centro (s.d.)', value: 'distance_to_center_std' },
            { text: 'Ángulo al centro (prom)', value: 'angle_to_center_mean' },
            { text: 'Ángulo al centro (s.d.)', value: 'angle_to_center_std' },
            { text: 'Ángulo de giro (prom)', value: 'turning_angle_mean' },
            { text: 'Ángulo de giro (s.d.)', value: 'turning_angle_std' },
        ],
    }),

    computed: {
        itemId() {
            return this.item['id']
        },
        items() {
            try {
                return JSON.parse(this.serie['variables']);
            } catch(e) {
                return [];
            }
        },

        categories() {
            var array = [];
            for (var item of this.items) {
                array.push(item['number']);
            }
            return array;
        },
        chartOptions() {
            return {
                chart: {
                    id: 'vuechart-example'
                },
                xaxis: {
                    categories: this.categories
                }
            }
        },
        series() {
            var array = [];

            for (var item of this.items) {
                array.push(item[this.selected.key].toFixed(2));
            }
        
            return [{
                name: 'series-1',
                data: array
            }]
        },
  
        serie() {
            //console.log(this.$store.state.serie);
            return this.$store.state.serie
        },

        options() {
            if (this.items.length > 0) {
                return this.optionsBase.filter(o => Object.keys(this.items[0]).includes(o.key))
            }
            return this.optionsBase
        },

        headers() {
            if (this.items.length > 0) {
                return this.headersBase.filter(o => Object.keys(this.items[0]).includes(o.value))
            }
            return this.headersBase
        },
    },

    watch: {
        dialog (val) {
            if (!val) {
                this.selected = {name: 'Acierto', key: 'success'};
            }
        }
    },

    created () {
        this.initialize()
    },

    methods: {
        initialize () {
            this.selected = {name: 'Acierto', key: 'success' },
            this.$store.dispatch('loadSerieDetail', {id: this.itemId})
        },

        updateClose () {
            this.$emit('close-dialog', false);
        },

        openDiagrama () {
            window.open(process.env.VUE_APP_HOST + "viewer/" + this.itemId);
        },

        round(number) {		
            return number.toFixed(1);
        },

        round3(number) {		
            return number.toFixed(3);
        },

        percent(number) {		
            return (number * 100).toFixed(0);
        },

        isSuccess(value) {
            return value == 1  ? "Sí" : "No";
        },

        changeSelected(value) {
            this.selected = this.options.find(x => x.name === value);
        }
    },

    components: {
        apexcharts: VueApexCharts,
    }

}
</script>